import { ButtonProps } from '@chakra-ui/react';

export const closeBtn: ButtonProps = {
  variant: 'unstyled',
  pos: 'absolute',
  top: [0, null, '30px'],
  right: [0, null, '34px'],
  boxSize: '40px',
  color: ['white', null, 'alpha.600'],

  sx: {
    svg: {
      boxSize: ['26px', null, '33px'],
    },
  },
};
